var exports = {
  "iE": "x61f99309--47e438--wrapper",
  "DD": "x61f99309--47e438--title",
  "Qq": "x61f99309--47e438--text",
  "x6": "x61f99309--47e438--button",
};

module.exports = exports;
